import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
  Spin,
  Space,
  Radio,
} from 'antd';
import { get, save, setPending } from '../redux/actions/actividadActions';
import { getAll as getAllSociedades } from '../redux/actions/sociedadActions';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import dayjs from 'dayjs';
import {
  ExclamationCircleOutlined,
  DeleteFilled,
  EditFilled,
  PlusOutlined,
} from '@ant-design/icons';
import { compareObject } from '../utils/funtions';
import { callStatus } from '../utils/constants';
import { Notificacion } from './Notificacion';
import MetaTable from './base/MetaTable';
import InversorEditor from './InversorEditor';
import { setPending as setPendingInversor } from '../redux/actions/inversorActions';

import {
  DraggableModal,
  DraggableModalProvider,
} from 'ant-design-draggable-modal';

const { Option } = Select;

const { confirm } = Modal;

const ActividadEditor = ({
  dispatch,
  id,
  stateData,
  visible,
  onCancel,
  establecimiento,
  cultivo,
  parentId,
  inversor,
  sociedad,
}) => {
  const [form] = Form.useForm();

  const [modoIngreso, setModoIngreso] = useState('aportante');

  const handleModoChange = (e) => {
    setModoIngreso(e.target.value);
    setInversores([]);
    form.setFieldsValue({
      search_inversor_id: null,
      sociedad_id: null,
      inversores: [],
    });
  };

  const [showEditInversor, setShowEditInversor] = useState(false);
  const [inversorId, setInversorId] = useState(null);

  const handleEditInversor = (id) => {
    setInversorId(id);
    setShowEditInversor(true);
  };

  const handleHideEditorInversor = () => {
    setShowEditInversor(false);
    setInversorId(null);
    dispatch(setPendingInversor());
  };

  const format = 'YYYY-MM-DD';
  const formatDisplay = 'DD/MM/YYYY';

  useEffect(() => {
    if (id) {
      dispatch(get(id));
    } else {
      dispatch(setPending());
    }
    getAllSociedades(dispatch);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      inversor.object.status === callStatus.OBJECT_SAVE_SUCCESS &&
      showEditInversor
    ) {
      const savedInversor = inversor.object.data;
      if (!inversorId) {
        setInversores((prev) => {
          if (!prev.some((p) => p.inversor_id === savedInversor.id)) {
            return [
              ...prev,
              {
                inversor_id: savedInversor.id,
                inversor_nombre: savedInversor.nombre,
              },
            ];
          }
          return prev;
        });
      } else {
        setInversores((prev) =>
          prev.map((p) =>
            p.inversor_id === savedInversor.id
              ? { ...p, inversor_nombre: savedInversor.nombre }
              : p
          )
        );
      }
    }
  }, [
    inversor.object.status,
    showEditInversor,
    inversorId,
    inversor.object.data,
  ]);

  useEffect(() => {
    let data = cloneDeep(stateData.object.data);
    data['fecha'] = moment(moment(data.fecha));

    if (stateData.object.status === callStatus.OBJECT_SUCCESS) {
      data['fecha'] = moment(moment(data.fecha));

      if (stateData.object.data.establecimiento) {
        setResultSearchEstablecimiento([stateData.object.data.establecimiento]);
      }

      if (data.sociedad_id) {
        setModoIngreso('sociedad');
      } else {
        setModoIngreso('aportante');
      }

      if (stateData.object.data.inversores) {
        setInversores(stateData.object.data.inversores);
      }
    } else if (stateData.object.status === callStatus.OBJECT_PENDING) {
      form.resetFields();
      setInitial({});
      setInversores([]);
    } else if (stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) {
      Notificacion('El registro se guardó con éxito', 'success', onCancel);
    } else if (stateData.object.status === callStatus.OBJECT_FAILED) {
      Notificacion(stateData.object.error, 'error', () => {});
    }
    form.setFieldsValue(data);
    setInitial(data);
    // eslint-disable-next-line
  }, [stateData.object]);

  const onCreate = (data) => {
    data.fecha = dayjs(new Date(data.fecha).toISOString()).format(format);
    data.campana_id = parentId;
    if (modoIngreso === 'aportante') {
      data.sociedad_id = null;
    }
    dispatch(save(data));
  };

  const [initial, setInitial] = useState({});

  const handleOnCancel = () => {
    if (compareObject(initial, form.getFieldsValue())) {
      confirm({
        title: 'Posee cambios sin guardar, desea continuar?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Si',
        cancelText: 'No',
        autoFocusButton: 'cancel',
        onOk() {
          onCancel();
        },
        onCancel() {},
      });
    } else {
      onCancel();
    }
  };
  const [establecimientoData, setEstablecimientoData] = useState([]);
  const [resultSearchEstablecimiento, setResultSearchEstablecimiento] =
    useState([]);

  const onSearchEstablecimiento = (value) => {
    const result = establecimientoData.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase())
    );
    setResultSearchEstablecimiento(result);
  };

  useEffect(() => {
    setEstablecimientoData(establecimiento.list.data);
    // eslint-disable-next-line
  }, [establecimiento]);

  const handleDelete = (data) => {
    setInversores((prev) =>
      prev.filter((item) => item.inversor_id !== data.inversor_id)
    );
  };

  const handleConfirmDelete = (item) => {
    confirm({
      title: '¿Está a punto de quitar un aportante, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const [inversores, setInversores] = useState([]);
  let columnsInversor = [
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={() => handleEditInversor(record.inversor_id)} />
          {modoIngreso !== 'sociedad' && (
            <DeleteFilled onClick={() => handleConfirmDelete(record)} />
          )}
        </Space>
      ),
      width: 60,
    },
    {
      ellipsis: true,
      title: 'Nombre',
      dataIndex: 'inversor_nombre',
    },
  ];

  if (modoIngreso === 'sociedad') {
    columnsInversor.push({
      title: 'Ganancia Insumo',
      dataIndex: 'ganancia',
      render: (text, record) => (
        <Input
          type="number"
          value={text || ''}
          onChange={(e) => {
            const val = e.target.value;
            setInversores((prev) =>
              prev.map((i) =>
                i.inversor_id === record.inversor_id
                  ? { ...i, ganancia: val }
                  : i
              )
            );
          }}
        />
      ),
    });
  }

  const [inversorData, setInversorData] = useState([]);

  useEffect(() => {
    setInversorData(inversor.list.data);
    // eslint-disable-next-line
  }, [inversor]);

  const [resultSearchInversor, setResultSearchInversor] = useState([]);

  const onSearchInversor = (value) => {
    const result = inversorData.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase())
    );
    setResultSearchInversor(result);
  };

  const onChangeInversor = (value) => {
    const result = inversorData.find((item) => item.id === value);

    setInversores([
      ...inversores,
      { inversor_id: result.id, inversor_nombre: result.nombre },
    ]);

    setResultSearchInversor([]);
    form.setFieldsValue({
      search_inversor_id: null,
    });
  };

  const onChangeSociedad = (value) => {
    if (!value) {
      setInversores([]);
      return;
    }
    const soc = sociedad.list.data.find((s) => s.id === value);
    if (soc && soc.inversores) {
      const mapeados = soc.inversores.map((inv) => ({
        inversor_id: inv.inversor_id,
        inversor_nombre: inv.inversor_nombre,
        ganancia: inv.ganancia,
      }));
      setInversores(mapeados);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      inversores: inversores,
    });
    // eslint-disable-next-line
  }, [inversores]);

  return (
    <>
      <DraggableModalProvider>
        <DraggableModal
          mask
          initialWidth={600}
          initialHeight={600}
          maskClosable={false}
          visible={visible}
          title={
            stateData.object.data.id ? 'Editar Actividad' : 'Nueva Actividad'
          }
          okText="Guardar"
          cancelText="Salir"
          onCancel={handleOnCancel}
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                onCreate(values);
              })
              .catch((info) => {
                console.log('Validate Failed:', info);
              });
          }}
        >
          <Spin
            spinning={
              stateData.object.status === callStatus.OBJECT_IN_PROCESS ||
              !!(id && stateData.object.status === callStatus.OBJECT_PENDING)
            }
          >
            <Form form={form} layout="vertical" name="form_in_modal">
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="id" label="id" style={{ display: 'none' }}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item name="fecha" label="Fecha Alta">
                    <DatePicker
                      format={formatDisplay}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item name="superficie" label="Superficie">
                    <Input type="number" addonBefore="ha" />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="establecimiento_id"
                    label="Establecimiento"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      defaultActiveFirstOption={false}
                      showArrow={false}
                      filterOption={false}
                      onSearch={onSearchEstablecimiento}
                      onChange={(value) => {
                        const est = establecimientoData.find(
                          (e) => e.id === value
                        );
                        if (est && est.superficie) {
                          form.setFieldsValue({ superficie: est.superficie });
                        }
                      }}
                      notFoundContent={null}
                      allowClear
                    >
                      {resultSearchEstablecimiento.map((item, index) => (
                        <Option key={index} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="cultivo_id"
                    label="Cultivo"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Select>
                      {cultivo.list.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[8, 0]} align="middle">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <div style={{ marginBottom: 16 }}>
                    <Radio.Group
                      value={modoIngreso}
                      onChange={handleModoChange}
                      optionType="button"
                      buttonStyle="solid"
                      style={{ width: '100%' }}
                    >
                      <Radio.Button
                        value="aportante"
                        style={{ width: '50%', textAlign: 'center' }}
                      >
                        Aportante Individual
                      </Radio.Button>
                      <Radio.Button
                        value="sociedad"
                        style={{ width: '50%', textAlign: 'center' }}
                      >
                        Sociedad
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {modoIngreso === 'aportante' ? (
                      <>
                        <Form.Item
                          label="Aportantes"
                          name="search_inversor_id"
                          style={{
                            flex: 1,
                          }}
                        >
                          <Select
                            showSearch
                            optionFilterProp="children"
                            defaultActiveFirstOption={false}
                            showArrow={false}
                            filterOption={false}
                            onSearch={onSearchInversor}
                            onChange={onChangeInversor}
                            notFoundContent={null}
                            allowClear
                            placeholder="Buscar Aportante"
                          >
                            {resultSearchInversor.map((item, index) => (
                              <Option key={index} value={item.id}>
                                {item.nombre}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <div style={{ marginTop: '5px' }}>
                          <PlusOutlined
                            onClick={() => {
                              setInversorId(null);
                              setShowEditInversor(true);
                            }}
                            style={{ paddingLeft: '7px', cursor: 'pointer' }}
                          />
                        </div>
                      </>
                    ) : (
                      <Form.Item
                        label="Sociedad"
                        name="sociedad_id"
                        rules={[{ required: true, message: 'Requerido' }]}
                        style={{ flex: 1 }}
                      >
                        <Select
                          allowClear
                          placeholder="Seleccionar Sociedad"
                          onChange={onChangeSociedad}
                        >
                          {sociedad.list.data &&
                            sociedad.list.data.map((item, index) => (
                              <Option key={index} value={item.id}>
                                {item.nombre}
                              </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    )}
                  </div>
                </Col>
              </Row>

              <Row>
                <Form.List
                  name="inversores"
                  rules={[
                    {
                      validator: async (_, inversores) => {
                        if (!inversores || inversores.length < 1) {
                          return Promise.reject(
                            new Error('Seleccione al menos un aportante')
                          );
                        }
                      },
                    },
                  ]}
                >
                  {(fields, { add, remove }, { errors }) => (
                    <>
                      {errors.length > 0 && (
                        <Row
                          gutter={[0, 0]}
                          style={{ width: '100%' }}
                          align="top"
                          justify="center"
                        >
                          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item>
                              <Form.ErrorList errors={errors} />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                </Form.List>
                {inversores && inversores.length > 0 && (
                  <MetaTable
                    dataSource={inversores}
                    dataColumns={columnsInversor}
                    bordered={false}
                    selection={false}
                    cssStyle={true}
                  />
                )}
              </Row>
            </Form>
          </Spin>
        </DraggableModal>
        {showEditInversor ? (
          <InversorEditor
            id={inversorId}
            onCancel={handleHideEditorInversor}
            visible={true}
          />
        ) : (
          false
        )}
      </DraggableModalProvider>
    </>
  );
};

const mapStateToProps = (state) => {
  const { actividad, establecimiento, cultivo, inversor, sociedad } = state;
  const stateData = actividad;
  return {
    stateData,
    establecimiento,
    cultivo,
    inversor,
    sociedad,
  };
};
export default connect(mapStateToProps)(ActividadEditor);
